import { render, staticRenderFns } from "./VariableIncome.vue?vue&type=template&id=71ea6e7a"
import script from "./VariableIncome.vue?vue&type=script&lang=js"
export * from "./VariableIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports